<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>订单设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">增值服务订单设置</div>
      </div>
    </div>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="图片设置" name="1">
          <serviceImg ref="serviceImg" />
        </TabPane>
        <TabPane label="文件设置" name="2">
          <serviceFile ref="serviceFile" />
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import serviceImg from "../components/common-service-img.vue";
import serviceFile from "../components/common-service-file.vue";

export default {
  name: "host-common-ad",
  data() {
    return {
      showTabs: "1",
    };
  },
  methods: {
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=img`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=file`);
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (query && query.type && query.type === "img") {
      this.showTabs = "1";
    }
    if (query && query.type && query.type === "file") {
      this.showTabs = "2";
    }
  },
  components: {
    serviceImg,
    serviceFile,
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
}
</style>